import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useConfig } from "@/hooks/useConfig";

// FX1 C2 — Brand dropdown source for the OPS pages.
// Switch OPS_BRAND_LINK ON  → live brands from the brand master (brand_id saved + name text).
// Switch OFF (default)      → exactly today: the ops_brands config list, text only.
export function useOpsBrands() {
  const { getValues, getItems } = useConfig();
  const configBrands = getValues("ops_brands");
  const flags = getItems("feature_flags");
  const brandLinkOn = String(
    (flags.find(f => f.key === "OPS_BRAND_LINK") || {}).value || "false"
  ).toLowerCase() === "true";

  const [masterBrands, setMasterBrands] = useState([]);

  useEffect(() => {
    if (!brandLinkOn) { setMasterBrands([]); return; }
    let alive = true;
    api.get("/brands/options", { params: { live_only: true } })
      .then(({ data }) => { if (alive) setMasterBrands(data || []); })
      .catch(() => { if (alive) setMasterBrands([]); });
    return () => { alive = false; };
  }, [brandLinkOn]);

  // One shape for both modes so the pages stay simple.
  const brandOptions = brandLinkOn
    ? masterBrands.map(b => ({ id: b._id, name: b.display_name || b.name }))
    : (configBrands || []).map(b => ({ id: "", name: b }));

  return { brandLinkOn, brandOptions };
}
